import { BrandMark, ButtonRouterLink, MonoLabel, ThemeToggle } from '../components/primitives';
import { useTheme } from '../lib/theme';
import { IdeDownloadPanel } from './IdeDownloadPanel';
import './Landing.css';

/**
 * Public macOS IDE download page — Gatekeeper callout + `.dmg` link.
 * Linked from marketing `/landing` and signed-in rail.
 */
export function Download() {
  const [theme, setTheme] = useTheme();

  return (
    <div className="lp" id="top">
      <header className="lp-chrome">
        <div className="pn-page lp-chrome-inner">
          <ButtonRouterLink to="/landing" variant="ghost" className="lp-download-back">
            ← Back to home
          </ButtonRouterLink>
          <span className="lp-grow" />
          <a href="/landing" className="lp-brand">
            <BrandMark className="lp-brand-mark" />
            <span className="lp-brand-word">Penrose</span>
            <MonoLabel size="md" tracking="wide" className="lp-brand-ser">
              v0.4 · build 1142
            </MonoLabel>
          </a>
          <span className="lp-grow" />
          <div className="lp-chrome-actions">
            <ThemeToggle theme={theme} onChange={setTheme} />
            <ButtonRouterLink to="/sign-in">Sign in</ButtonRouterLink>
            <ButtonRouterLink to="/sign-up" variant="primary">
              Start free
            </ButtonRouterLink>
          </div>
        </div>
      </header>

      <main className="pn-download-page">
        <div className="pn-page">
          <div className="pn-download-hero">
            <h1 className="pn-download-title">Get the Penrose desktop app for your team</h1>
            <p className="pn-download-lede">
              Unsigned builds for early testers. Pick your platform — we&apos;ll
              preselect based on your device, but switch any time. Both builds
              link to GitHub Releases for the latest tag.
            </p>
          </div>
          <IdeDownloadPanel />
        </div>
      </main>

      <footer className="pn-download-footer pn-page">
        <p>
          Need help? Check the{' '}
          <a
            href="https://github.com/MalakHimse1f/penrose-ide#readme"
            target="_blank"
            rel="noopener noreferrer"
          >
            docs
          </a>{' '}
          or{' '}
          <a
            href="https://github.com/MalakHimse1f/penrose-ide/issues/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            open an issue
          </a>{' '}
          on GitHub.
        </p>
      </footer>
    </div>
  );
}
